<template>
  <div id="app">
    <v-app>
      <v-app-bar
        class="navbar-expand-lg"
        color="rgba(255, 255, 255, 0.9)"
        app
        height="100px"
      >
        <div class="middlenav collapse navbar-collapse">
          <v-btn href="#page-top" text>
            <div>
              <v-img
                src="./assets/mayexportslogo.png"
                max-height="300px"
                max-width="100px"
              ></v-img></div
          ></v-btn>

          <v-toolbar-title
            ><a class="navbar-brand" style="color:#231f20" href="#page-top"
              ><span style="font-size:14px;"
                >MAY Exports 
                <div style="font-size:12px;">Ho Chi Minh City, Vietnam</div></span
              ></a
            ></v-toolbar-title
          >

          <v-spacer></v-spacer>

          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="aHover = true"
            v-if="aHover === false"
            text
            href="#about"
            ><i class="fas fa-info-circle fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;transform: scale(1.2);"
            @mouseleave="aHover = false ;
    gHover= false,
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="aHover === true"
            text
            href="#about"
            >About
          </v-btn>

          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="pHover = true"
            v-if="pHover === false"
            text
            href="#portfolio"
            ><i class="fas fa-truck fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;transform: scale(1.2);"
            @mouseleave="aHover = false ;
    gHover= false,
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="pHover === true"
            text
            href="#portfolio"
            >Products
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;transform: scale(1.2);"
            @mouseleave="aHover = false ;
    gHover= false,
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="fHover === true"
            text
            href="#team"
            >Fruit Calender
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="fHover = true"
            v-if="fHover === false"
            text
            href="#team"
            ><i class="fas fa-calendar-alt fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;transform: scale(1.2);"
            @mouseleave="aHover = false ;
    gHover= false,
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="sHover === true"
            text
            href="#services"
            >Activities
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="sHover = true"
            v-if="sHover === false"
            text
            href="#services"
            ><i class="fas fa-newspaper fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="caHover = true"
            v-if="caHover === false"
            text
            href="#careers"
            ><i class="fas fa-users fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;transform: scale(1.2);"
            @mouseleave="aHover = false ;
    gHover= false,
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="caHover === true"
            text
            href="#careers"
            >Careers
          </v-btn>
          <v-btn
            style="color:#ea1e29;text-decoration:none;"
            @mouseover="gHover = true"
            v-if="gHover === false"
            text
            href="#gallery"
            ><i class="fas fa-images fa-lg"></i>
          </v-btn>
          <v-btn
            style="color:#ea1e29;;text-decoration:none;transform: scale(1.2);"
            @mouseleave="gHover = false ;
            aHover = false ;
    pHover= false,
    sHover= false,
    fHover= false,
    caHover=false"
            v-if="gHover === true"
            text
            href="#gallery"
            >Gallery
          </v-btn>

          <v-btn
            style="color:#ea1e29;background-color:#231f20;text-decoration:none;"
            v-if="cHover === false"
            rounded
            href="#contact"
            @mouseover="cHover = true"
            >Contact
          </v-btn>
          <v-btn
            style="background-color:#ea1e29;color:#231f20;text-decoration:none;"
            @mouseleave="cHover = false"
            v-if="cHover === true"
            rounded
            href="#contact"
            >Contact
          </v-btn>
        </div>

        <a
          class="emmaylogoshrink navbar-toggler-right"
          href="#page-top"
          data-toggle="collapse"
          ><v-img
            src="./assets/mayexportslogo.png"
            max-height="200px"
            max-width="100px"
          ></v-img
        ></a>
        <v-spacer class="emmaylogoshrink navbar-toggler-right"></v-spacer>
        <i
          class="fas fa-bars fa-2x emmaylogoshrink navbar-toggler-right "
          @click.stop="drawer = !drawer"
        ></i>

        <v-navigation-drawer
          right
          color="rgba(245, 245, 245, 0.9)"
          app
          width="100%"
          height="auto"
          v-model="drawer"
          absolute
          temporary
        >
          <v-list dense style="background-color:rgba(245, 245, 245, 0.8)">
            <v-list-item href="#page-top" @click.stop="drawer = !drawer">
              <v-img
                src="./assets/mayexportslogo.png"
                @click.stop="drawer = !drawer"
                max-height="200px"
                max-width="100px"
              ></v-img>

              <v-list-item-content>
                <v-list-item-title>
                  <a class="navbar-brand" style="color:#ea1e29" href="#page-top"
                    ><span style="font-size:14px; padding-left:10px;"
                      >MAYExports
                      <div style="font-size:12px; padding-left:10px;">
                        Ho Chi Minh City, Vietnam
                      </div></span
                    ></a
                  >
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>

          <v-list nav dense class="shrinkMenu">
            <v-list-item
              v-for="nlink in nlinks"
              :key="nlink.id"
              link
              :href="nlink.ref"
              @click.stop="drawer = !drawer"
            >
              <v-list-item-icon>
                <i :class="nlink.icon" style="color:#ea1e29"></i>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="color:#ea1e29">{{ nlink.title }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </v-app-bar>

      <!-- <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
    <div class="container">
      <a class="emmaylogo js-scroll-trigger collapse navbar-collapse"  href="#page-top"><v-img src="./assets/emmaylogo.png"  max-height="800px" max-width="150px"></v-img></a> <a class="navbar-brand js-scroll-trigger collapse navbar-collapse"  href="#page-top"><span  style="font-size:20px;">Emmay Commodities<div style="font-size:16px;">Cape Town,South Africa</div></span></a>
      <a class="emmaylogoshrink navbar-toggler-right"  href="#page-top" data-toggle="collapse"><v-img src="./assets/emmaylogo.png"  max-height="200px" max-width="100px"></v-img></a>
      <button class="navbar-toggler navbar-toggler-right " type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
     
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav text-uppercase ml-auto">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">About</a>
          </li>
          
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#portfolio">Products</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#services">Activities</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#team">Gallery</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#contact">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav> -->
      <v-sheet id="scrolling-techniques" class="overflow-y-auto">
        <!-- Header -->

        <v-carousel height="800" dark show-arrows-on-hover cycle  >
          <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src" 
            ><header class="masthead">
              <div class="container">
                <div class="intro-text">
                  <div class="intro-lead-in">Welcome To</div>
                  <div class="intro-heading text-uppercase">
                    May Exports Vietnam
                  </div>
                  <a
                    class="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
                    href="#about"
                    >Tell Me More</a
                  >
                </div>
              </div>
            </header>

            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-carousel-item>
        </v-carousel>
<!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->

        <!-- About -->
        <About></About>
<!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->
        <!-- Portfolio Grid -->
        <Portfolio></Portfolio>
        <!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->

        <!-- Team -->
        <Team></Team>
        <!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->

        <!-- Services -->
        <Services></Services>
        <!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->
<careers></careers>
<!-- <v-divider  style="background-color:#ea1e29;"></v-divider> -->

        <!-- Gallery -->
        <Gallery></Gallery>

        <!-- Clients -->
<!-- <v-divider style="background-color:#ea1e29;"></v-divider> -->

        <!-- Contact -->
        <section class="page-section" id="contact">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 text-center">
                <h2 class="section-heading text-uppercase">Contact Us</h2>
                <h3 class="section-subheading text-muted">
                  Reach out and connect with us.
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <form action="https://app.99inbound.com/api/e/k_z6u0c1" method="POST" target="_blank">

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input
                          class="form-control"
                          id="name"
                          type="text"
                          name="name"
                          placeholder="Your Name *"
                          required="required"
                          data-validation-required-message="Please enter your name."
                        />
                        <p class="help-block text-danger"></p>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          id="email"
                          type="email"
                          name="email"
                          placeholder="Your Email *"
                          required="required"
                          data-validation-required-message="Please enter your email address."
                        />
                        <p class="help-block text-danger"></p>
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          id="phone"
                          type="tel"
                          name="tel"
                          placeholder="Your Phone *"
                          required="required"
                          data-validation-required-message="Please enter your phone number."
                        />
                        <p class="help-block text-danger"></p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          id="message"
                          name="message"
                          placeholder="Your Message *"
                          required="required"
                          data-validation-required-message="Please enter a message."
                        ></textarea>
                        <p class="help-block text-danger"></p>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-lg-12 text-center">
                      <div id="success"></div>
                      <button
                        id="sendMessageButton"
                        class="btn btn-primary btn-xl text-uppercase"
                        type="submit"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
                <div class="col-lg-12 text-center ">
                  <button
                    class="btn btn-primary btn-xl emailcol"
                  >
                   Sales Enquires:  <i class="fas fa-envelope"></i>&nbsp; vietnamexports@mayexports.com
                  </button>
                </div>
                <div class="col-lg-12 text-center ">
                  <button
                    class="btn btn-primary btn-xl text-uppercase emailcol"
                  >
                    <i class="fas fa-phone"></i> &nbsp; +84 28 66521105 || +84 28 66525105
                  </button>
                </div>
                <div class="col-lg-12 text-center ">
                  <button
                    class="btn btn-primary btn-xl text-uppercase emailcol"
                  >
                    <a
                      class="location"
                      href="https://www.google.com/maps/place/MAY+Exports+Vietnam+Company+Limited/@10.7179015,106.6824736,17z/data=!3m1!4b1!4m5!3m4!1s0x3175255bab184b9f:0xbfd4105062d3fe54!8m2!3d10.7179015!4d106.6846623?hl=en-US"
                      target="_blank"
                      ><i class="fas fa-map-marker-alt"></i> &nbsp;
                      46 Chanh Hung Street, Hamlet 5, Binh Hung Commune, Binh Chanh Dist,

Ho Chi Minh City, Vietnam </a
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Footer -->
        <footer class="footer">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-4">
                <span class="copyright"
                  >Copyright &copy; MAYExports Vietnam</span
                >
              </div>
              <div class="col-md-4">
                <ul class="list-inline social-buttons">
                  
                  <li class="list-inline-item">
                    <a
                      href="https://www.facebook.com/pages/category/Shopping---Retail/MAY-Exports-Vietnam-Company-Limited-261473418097596/"
                      target="_blank"
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="https://www.linkedin.com/company/may-exports-vietnam-company-limited/about/" target="_blank">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-4">
                <ul class="list-inline quicklinks">
                  <li class="list-inline-item">
                    <a
                      href="https://www.linkedin.com/in/georgeo-thanathara-a3274b188"
                      target="_blank"
                      >Created & Designed by Georgeo</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </v-sheet>
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-app>
  </div>
</template>

<script>
import Portfolio from "./components/Portfolio.vue";
import About from "./components/About.vue";

import Services from "./components/Services.vue";
import Team from "./components/Team.vue";

import Gallery from "./components/Gallery.vue";
import careers from "./components/careers.vue"

//import Clients from './components/Clients.vue';

export default {
  name: "App",
  components: {
    Portfolio,
    About,
    Services,
    Team,
    Gallery,
    careers
    // Clients,
  },

  data: () => ({
    items: [
      {
        src: require("./assets/img/tet.jpg")
      },
     

      {
        src: require("./assets/img/tettwo.jpg")
      },
      
    ],
    drawer: null,
    nlinks: [
      {
        title: "About",
        icon: "fas fa-address-card",
        ref: "#about"
      },
      {
        title: "Products",
        icon: "fas fa-truck",
        ref: "#portfolio"
      },
      {
        title: "Fruit Calender",
        icon: "far fa-calendar-alt",
        ref: "#team"
      },
      {
        title: "Activities",
        icon: "fas fa-newspaper",
        ref: "#services"
      },
      {
        title: "Careers",
        icon: "fas fa-users",
        ref: "#careers"
      },
      {
        title: "Gallery",
        icon: "fas fa-images",
        ref: "#gallery"
      },
      {
        title: "Contact",
        icon: "fas fa-id-card",
        ref: "#contact"
      }
    ],
    cHover: false,
    gHover: false,
    pHover: false,
    sHover: false,
    fHover: false,
    aHover: false,
    caHover:false
  })
};
</script>
<style scoped>
.logoemmay {
  margin-top: 20px;
  width: 150px;
  height: auto;
}

.carousel {
  background-color: black;
}
.emailcol {
  background-color: rgba(255, 255, 255, 0.8);
  color: #392f51;
}
.location {
  text-decoration: none;
  color: #392f51;
}
hr{
   margin-top: 0;
   margin-bottom:0;
   padding: 8px;
}
@media screen and (max-height: 380px) {
  .shrinkMenu {
    height: 180px;
    overflow-y: auto;
  }
  
}
</style>
